import React from 'react';

import type { IconProps } from './IconBase';
import { ReactComponent as RefreshSvg } from './refresh.svg';

export const IconRefresh: React.FunctionComponent<IconProps> = ({
  width = 24,
  height = 24,
  color,
  className,
}) => (
  <RefreshSvg
    width={width}
    height={height}
    className={className}
    style={color !== undefined ? { color } : undefined}
  />
);
